


















import { Component, Mixins, Watch } from 'vue-property-decorator';

// components
import NavBar from '@/components/layout/NavBar.vue';
import PartnerList from '@/components/partner/PartnerList.vue';

// mixins
import Pagination from '@/mixins/pagination';

// gql
import fetchPartnerList from '@/graphql/queries/partners/FetchPartnerList.gql';
import { PartnerFields } from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    partners: {
      query: fetchPartnerList,
      variables() {
        return {
          pagination: {
            page: parseInt((this.$route.query.page as string), 10) || this.currentPage,
            per: parseInt((this.$route.query.size as string), 10) || this.paginationSize
          }
        };
      },
      update(data) {
        this.totalCount = data ? data.partnersPagination.totalCount : 0;
        return data && data.partners;
      },
      fetchPolicy: 'cache-and-network',
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 2000
        });
      }
    }
  },
  components: {
    NavBar,
    PartnerList
  }
})
export default class List extends Mixins(Pagination) {
  private partners: PartnerFields[] = [];
}
